import React, { Component } from 'react';
// import { getFileName } from '../../../helpers/FileCaching';
import classes from './Footer.module.scss';
import globalJson from '../../../data/global.json';

class Footer extends Component {

    constructor(props) {
        super(props);
        this.globalImages = this.props.globalImages;
    }

    render() {
        return (
            <footer>
                <div className="container">
                    <p className="footer__title">{globalJson.footer.text}<a className="footer__link" href={globalJson.footer.link} target="_blank"> Read more</a></p>
                </div>
            </footer>
        )
    }
}

export default Footer;